module.exports = __webpack_public_path__ + "static/media/man-woman-making-plans-renovate-house-using-color-palette-laptop_1709045633488.9a9596f8.jpg";